import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: string; output: string; }
  /** The `DateTimeOffset` scalar type represents a date, time and offset from UTC. `DateTimeOffset` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTimeOffset: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Long: { input: number; output: number; }
};

export type ActionType = {
  __typename?: 'ActionType';
  /** The code of the action. */
  code?: Maybe<Scalars['String']['output']>;
  /** The id of the action. */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of the action. */
  name?: Maybe<Scalars['String']['output']>;
  /** The sort id of the action. */
  sortId?: Maybe<Scalars['String']['output']>;
  /** The sub action codes of the action. */
  subActionCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type AddressType = {
  __typename?: 'AddressType';
  /** Address1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address3 */
  address3?: Maybe<Scalars['String']['output']>;
  /** Service Region for Evatic */
  areaCode?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** PostalCode */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** PostalPlace */
  postalPlace?: Maybe<Scalars['String']['output']>;
};

export type AreaType = {
  __typename?: 'AreaType';
  /** Area code */
  areaCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The id of the area. */
  id: Scalars['ID']['output'];
  /** Technicians associated with the area */
  technicians: Array<Scalars['String']['output']>;
};

export type AsolviMobileMutation = {
  __typename?: 'AsolviMobileMutation';
  addChecklist?: Maybe<ChecklistType>;
  addUserConsent: Array<UserConsentType>;
  addWorkNote?: Maybe<WorkNoteType>;
  assignTask?: Maybe<Scalars['Boolean']['output']>;
  auth0Login?: Maybe<LoginResult>;
  changeJobMachine?: Maybe<Scalars['Boolean']['output']>;
  createServiceJob?: Maybe<CreateJobResult>;
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  insertComment?: Maybe<Scalars['Int']['output']>;
  logout?: Maybe<LogoutResult>;
  markCommentNotificationRead?: Maybe<Scalars['Boolean']['output']>;
  orderMobileStock?: Maybe<Scalars['Boolean']['output']>;
  preLogin?: Maybe<PreLoginResult>;
  rejectJobAssignment?: Maybe<Scalars['Boolean']['output']>;
  sendRemoteAccessEmail?: Maybe<Scalars['Boolean']['output']>;
  syncMobileStock?: Maybe<Scalars['Boolean']['output']>;
  updateAvailability?: Maybe<Scalars['Boolean']['output']>;
  updateComment?: Maybe<Scalars['Boolean']['output']>;
  updateContact?: Maybe<Scalars['Boolean']['output']>;
  updateJobStatus?: Maybe<ServiceJob>;
  updateJobsStatus?: Maybe<Scalars['Boolean']['output']>;
  updateMachineCustomProperties?: Maybe<ServiceJob>;
  updateMachineInstallDate?: Maybe<Scalars['Boolean']['output']>;
  updateMachineLocation?: Maybe<Scalars['Boolean']['output']>;
  updateMeters?: Maybe<Scalars['Boolean']['output']>;
  updatePlannedDate?: Maybe<Scalars['Boolean']['output']>;
  updateTechStatus?: Maybe<Scalars['Boolean']['output']>;
  updateTechnicianMetadata?: Maybe<Scalars['Boolean']['output']>;
  updateVisitWithParts?: Maybe<UpdateVisitResponse>;
  uploadFile?: Maybe<Scalars['Boolean']['output']>;
  userSettings: UserSettings;
};


export type AsolviMobileMutationAddChecklistArgs = {
  checklistCode: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type AsolviMobileMutationAddUserConsentArgs = {
  userConsents?: InputMaybe<Array<UserConsentInputType>>;
};


export type AsolviMobileMutationAddWorkNoteArgs = {
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
  workNote: WorkNoteInputType;
};


export type AsolviMobileMutationAssignTaskArgs = {
  jobId: Scalars['String']['input'];
  scheduleStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  technicianId: Scalars['String']['input'];
};


export type AsolviMobileMutationAuth0LoginArgs = {
  accessToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type AsolviMobileMutationChangeJobMachineArgs = {
  jobId: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationCreateServiceJobArgs = {
  files?: InputMaybe<Array<FileInputType>>;
  jobDetails?: InputMaybe<JobInputType>;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationDeleteCommentArgs = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationInsertCommentArgs = {
  comment: CommentInputType;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationMarkCommentNotificationReadArgs = {
  notificationIds: Array<Scalars['Int']['input']>;
};


export type AsolviMobileMutationOrderMobileStockArgs = {
  stocks?: InputMaybe<Array<SyncMobileStockInputType>>;
};


export type AsolviMobileMutationPreLoginArgs = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type AsolviMobileMutationRejectJobAssignmentArgs = {
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
  rejectReason: Scalars['String']['input'];
};


export type AsolviMobileMutationSendRemoteAccessEmailArgs = {
  email: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  peerId: Scalars['String']['input'];
};


export type AsolviMobileMutationSyncMobileStockArgs = {
  stocks?: InputMaybe<Array<SyncMobileStockInputType>>;
};


export type AsolviMobileMutationUpdateAvailabilityArgs = {
  availability: UpdateAvailabilityInputType;
};


export type AsolviMobileMutationUpdateCommentArgs = {
  comment: CommentInputType;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUpdateContactArgs = {
  contact: ContactInputType;
  customerId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUpdateJobStatusArgs = {
  jobId: Scalars['String']['input'];
  status: JobStatus;
};


export type AsolviMobileMutationUpdateJobsStatusArgs = {
  jobIds: Array<Scalars['String']['input']>;
  status: JobStatus;
};


export type AsolviMobileMutationUpdateMachineCustomPropertiesArgs = {
  jobId: Scalars['String']['input'];
  properties?: InputMaybe<Array<PropertyValueInputType>>;
};


export type AsolviMobileMutationUpdateMachineInstallDateArgs = {
  jobId: Scalars['String']['input'];
  machine: UpdateMachineInputType;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUpdateMachineLocationArgs = {
  jobId: Scalars['String']['input'];
  machine: UpdateMachineInputType;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUpdateMetersArgs = {
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
  meters?: InputMaybe<Array<MeterReadingInputType>>;
};


export type AsolviMobileMutationUpdatePlannedDateArgs = {
  jobId: Scalars['String']['input'];
  times?: InputMaybe<TimesInputType>;
};


export type AsolviMobileMutationUpdateTechStatusArgs = {
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<MetadataInputType>;
  status: Scalars['String']['input'];
};


export type AsolviMobileMutationUpdateTechnicianMetadataArgs = {
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUpdateVisitWithPartsArgs = {
  metadata?: InputMaybe<MetadataInputType>;
  updateVisit: UpdateVisitInputType;
};


export type AsolviMobileMutationUploadFileArgs = {
  file?: InputMaybe<FileInputType>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataInputType>;
};


export type AsolviMobileMutationUserSettingsArgs = {
  userSettings?: InputMaybe<UserSettingsInputType>;
};

export type AssignedTechnicianType = {
  technicianGuid?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityType = {
  __typename?: 'AvailabilityType';
  /** The Code of the availabilty type. */
  code?: Maybe<Scalars['String']['output']>;
  /** The Description of the availabilty type. */
  description?: Maybe<Scalars['String']['output']>;
  /** The SortId of the availabilty type. */
  sortId?: Maybe<Scalars['String']['output']>;
};

export type BasicDataType = {
  __typename?: 'BasicDataType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  sortId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CalendarProjectTaskType = {
  __typename?: 'CalendarProjectTaskType';
  actionText?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  itemGuid?: Maybe<Scalars['ID']['output']>;
  projectNo?: Maybe<Scalars['Int']['output']>;
  projectTaskAssignmentId?: Maybe<Scalars['Int']['output']>;
  taskNo?: Maybe<Scalars['Int']['output']>;
};

export type CalendarType = {
  __typename?: 'CalendarType';
  availability: Array<TechnicianAvailabilityType>;
  projectTasks: Array<CalendarProjectTaskType>;
  salesTasks: Array<SalesTaskType>;
};

export type ChecklistGroupsType = {
  __typename?: 'ChecklistGroupsType';
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ChecklistInputType = {
  checklistCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  machineGuid?: InputMaybe<Scalars['ID']['input']>;
  questions?: InputMaybe<Array<ChecklistQuestionInputType>>;
  title: Scalars['String']['input'];
};

export type ChecklistQuestionInputType = {
  answer?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dataType?: InputMaybe<QuestionDataType>;
  dropDownValues?: InputMaybe<Array<Scalars['String']['input']>>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionParams?: InputMaybe<Array<ExpressionParameterInputType>>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredPreStart?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Decimal']['input']>;
  minValue?: InputMaybe<Scalars['Decimal']['input']>;
  nodeKey?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  showComment?: InputMaybe<Scalars['Boolean']['input']>;
  showCondition?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChecklistQuestionType = {
  __typename?: 'ChecklistQuestionType';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  dataType: QuestionDataType;
  dropDownValues: Array<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  expressionParams: Array<ExpressionParameterType>;
  isRequired: Scalars['Boolean']['output'];
  isRequiredPreStart: Scalars['Boolean']['output'];
  maxValue?: Maybe<Scalars['Decimal']['output']>;
  minValue?: Maybe<Scalars['Decimal']['output']>;
  nodeKey?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  showComment: Scalars['Boolean']['output'];
  showCondition?: Maybe<Scalars['Boolean']['output']>;
};

export type ChecklistType = {
  __typename?: 'ChecklistType';
  checklistCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  machineGuid?: Maybe<Scalars['ID']['output']>;
  questions: Array<ChecklistQuestionType>;
  title: Scalars['String']['output'];
};

export type CommentInputType = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceGuid?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CommentMentionablesType = {
  __typename?: 'CommentMentionablesType';
  defaultMainServiceTeam: Scalars['Boolean']['output'];
  defaultTaskCreator: Scalars['Boolean']['output'];
  mainServiceTeamCode?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<TechnicianTeamType>>;
  technicians?: Maybe<Array<TechnicianType>>;
  users?: Maybe<Array<UserMentionType>>;
};

export type CommentNotificationType = {
  __typename?: 'CommentNotificationType';
  assignedTechnicianId?: Maybe<Scalars['String']['output']>;
  commentChangedDate?: Maybe<Scalars['DateTime']['output']>;
  commentCreatedDate?: Maybe<Scalars['DateTime']['output']>;
  commentId: Scalars['Int']['output'];
  commentOwnerFullName: Scalars['String']['output'];
  commentText: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  notificationId: Scalars['Int']['output'];
  notificationRead?: Maybe<Scalars['Boolean']['output']>;
  source: Scalars['String']['output'];
  sourceGuid: Scalars['ID']['output'];
  sourceIdText: Scalars['String']['output'];
};

export type CommentType = {
  __typename?: 'CommentType';
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  commentId: Scalars['Int']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  fullAccess?: Maybe<Scalars['Boolean']['output']>;
  owner: Scalars['String']['output'];
  ownerFullName?: Maybe<Scalars['String']['output']>;
  sourceGuid: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ContactInputType = {
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  contactNo?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContractType = {
  __typename?: 'ContractType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  typeObjNo?: Maybe<Scalars['ID']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type CoordinatesInputType = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type CoordinatesType = {
  __typename?: 'CoordinatesType';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type CreateJobResult = {
  __typename?: 'CreateJobResult';
  /** Determines if the job is provisionally assigned */
  isProvisional: Scalars['Boolean']['output'];
  /** The jobId of the created job */
  jobId?: Maybe<Scalars['String']['output']>;
};

export type CustomPropertyType = {
  __typename?: 'CustomPropertyType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  propertyGuid?: Maybe<Scalars['ID']['output']>;
  sourceGuid?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerContactType = {
  __typename?: 'CustomerContactType';
  /** Contact email */
  email?: Maybe<Scalars['String']['output']>;
  /** Contact first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The id of the customer contact. */
  id: Scalars['String']['output'];
  /** Contact last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Mobile number */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  /** Contact name */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerType = {
  __typename?: 'CustomerType';
  /** Address */
  address?: Maybe<AddressType>;
  /** Contacts associated with the customer */
  contacts: Array<CustomerContactType>;
  /** Customer Account Number */
  customerNo?: Maybe<Scalars['String']['output']>;
  /** The id of the customer. */
  id: Scalars['String']['output'];
  isOnStop: Scalars['Boolean']['output'];
  /** Customer name */
  name?: Maybe<Scalars['String']['output']>;
};

export type DatabaseCheckType = {
  __typename?: 'DatabaseCheckType';
  /** The email of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** Is the database up? */
  isUp: Scalars['Boolean']['output'];
};

export type Endpoint = {
  __typename?: 'Endpoint';
  apiUrl: Scalars['String']['output'];
  apiVersion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EndpointInputType = {
  apiUrl: Scalars['String']['input'];
  apiVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpressionParameterInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ExpressionParameterType = {
  __typename?: 'ExpressionParameterType';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type ExtraInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  isTime: Scalars['Boolean']['input'];
  quantity: Scalars['Decimal']['input'];
  salesPrice?: InputMaybe<Scalars['Decimal']['input']>;
  salesPriceChangedOnClient?: InputMaybe<Scalars['Boolean']['input']>;
  servicesCode?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
};

export type ExtraType = {
  __typename?: 'ExtraType';
  code: Scalars['String']['output'];
  company: Scalars['String']['output'];
  department: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTime: Scalars['Boolean']['output'];
  quantity: Scalars['Decimal']['output'];
  servicesCode: Scalars['String']['output'];
  sortNo?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  /** The value indicating if the user can access the feature or not. */
  isActive: Scalars['Boolean']['output'];
  /** The name of the feature. */
  name: Scalars['String']['output'];
};

export type FileInputType = {
  data: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fileGuid?: InputMaybe<Scalars['ID']['input']>;
  fileType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  useInServiceReport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileType = {
  __typename?: 'FileType';
  /** File data */
  data: Scalars['String']['output'];
  /** The description of the file */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the file */
  fileGuid?: Maybe<Scalars['ID']['output']>;
  /** The type of the file */
  fileType: Scalars['String']['output'];
  /** The id of the file */
  id: Scalars['ID']['output'];
  /** File size */
  isFullSize?: Maybe<Scalars['Boolean']['output']>;
  /** The file name */
  name: Scalars['String']['output'];
  /** File size */
  size?: Maybe<Scalars['Long']['output']>;
  useInServiceReport?: Maybe<Scalars['Boolean']['output']>;
};

export type FollowUpInputType = {
  followUpChecked: Scalars['Boolean']['input'];
};

export type JobFilterInputType = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  plannedDate?: InputMaybe<Scalars['DateTime']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  symptomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobInputType = {
  assignedTechnicians?: InputMaybe<Array<AssignedTechnicianType>>;
  /** Job's Customer Id */
  customerId: Scalars['String']['input'];
  /** Description of problem */
  description: Scalars['String']['input'];
  /** Id of the Machine */
  machineId?: InputMaybe<Scalars['String']['input']>;
  /** Date the job creation was received */
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Job's Symptom code 1 */
  symptomCodeId1: Scalars['String']['input'];
  /** Job's Symptom code 2 */
  symptomCodeId2?: InputMaybe<Scalars['String']['input']>;
  /** Job's Symptom code 3 */
  symptomCodeId3?: InputMaybe<Scalars['String']['input']>;
};

export type JobOptionsType = {
  __typename?: 'JobOptionsType';
  symptoms: Array<JobSymptomType>;
};

export enum JobStatus {
  Accepted = 'Accepted',
  Assigned = 'Assigned',
  Completed = 'Completed',
  Downloaded = 'Downloaded',
  InProgress = 'InProgress',
  Planned = 'Planned',
  Rejected = 'Rejected'
}

export type JobSymptomType = {
  __typename?: 'JobSymptomType';
  /** The Code of the symptom. */
  code?: Maybe<Scalars['String']['output']>;
  /** The Description of the symptom. */
  description?: Maybe<Scalars['String']['output']>;
  /** The SortId of the symptom. */
  sortId?: Maybe<Scalars['String']['output']>;
  /** The sub symptom codes of the symptom. */
  subSymptomCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type JobVisitInput = {
  actionId1: Scalars['String']['input'];
  actionId2?: InputMaybe<Scalars['String']['input']>;
  actionId3?: InputMaybe<Scalars['String']['input']>;
  checklists?: InputMaybe<Array<ChecklistInputType>>;
  customerSatisfaction?: InputMaybe<Scalars['Int']['input']>;
  customerSignatureImageData?: InputMaybe<Scalars['String']['input']>;
  customerSignerName?: InputMaybe<Scalars['String']['input']>;
  engineerSignatureImageData?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<ExtraInputType>>;
  followUp?: InputMaybe<FollowUpInputType>;
  parts?: InputMaybe<Array<PartInputType>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  serviceReportEmail?: InputMaybe<Scalars['String']['input']>;
  solutionDescription?: InputMaybe<Scalars['String']['input']>;
  travelTimes?: InputMaybe<Array<TimesInputType>>;
  workTimes?: InputMaybe<Array<TimesInputType>>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  /** The company name of the logged in user */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The email of the logged in user */
  email: Scalars['String']['output'];
  /** Token expiry */
  expiry: Scalars['DateTime']['output'];
  /** The full name of the logged in user */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The id of the logged in user */
  id: Scalars['String']['output'];
  /** The user prefered language */
  languageCode?: Maybe<Scalars['String']['output']>;
  /** The technician own stock id */
  stockId?: Maybe<Scalars['String']['output']>;
  /** The external GUID of the logged in user */
  technicianGuid?: Maybe<Scalars['ID']['output']>;
  /** The external id of the logged in user */
  technicianId: Scalars['String']['output'];
  /** The technician no of the logged in user */
  technicianNo?: Maybe<Scalars['String']['output']>;
  /** JWT */
  token: Scalars['String']['output'];
  /** User's consents */
  userConsents: Array<UserConsentType>;
};

export type LogoutResult = {
  __typename?: 'LogoutResult';
  /** Logout message */
  message: Scalars['String']['output'];
};

export type MachineDetailsType = {
  __typename?: 'MachineDetailsType';
  customProperties?: Maybe<Array<CustomPropertyType>>;
  information?: Maybe<Scalars['String']['output']>;
  sortGroups?: Maybe<Array<SortGroupValueType>>;
};

export type MachineType = {
  __typename?: 'MachineType';
  /** The Address of the machine */
  address?: Maybe<AddressType>;
  /** The machine's address row no. field */
  addressRowNo?: Maybe<Scalars['Int']['output']>;
  /** The CustomerId of the machine */
  customerId?: Maybe<Scalars['String']['output']>;
  /** The CustomerName of the machine */
  customerName?: Maybe<Scalars['String']['output']>;
  details?: Maybe<MachineDetailsType>;
  /** The machine's id field */
  id?: Maybe<Scalars['String']['output']>;
  /** The machine's asset number field */
  idNo?: Maybe<Scalars['String']['output']>;
  /** Limit for meters to decide if increase is too high */
  increaseLimit?: Maybe<Scalars['Decimal']['output']>;
  /** The machine's install date field */
  installDate?: Maybe<Scalars['DateTime']['output']>;
  /** The machine's location field */
  location?: Maybe<Scalars['String']['output']>;
  /** The machine's serial number field */
  machineNo?: Maybe<Scalars['String']['output']>;
  /** The machine's model guid field */
  modelGuid?: Maybe<Scalars['String']['output']>;
  /** The machine's name field */
  name?: Maybe<Scalars['String']['output']>;
  servicesCode?: Maybe<Scalars['String']['output']>;
};

export type MetadataInputType = {
  coordinates?: InputMaybe<CoordinatesInputType>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MeterReadingInputType = {
  currentReading?: InputMaybe<Scalars['Int']['input']>;
  currentReadingDate?: InputMaybe<Scalars['DateTime']['input']>;
  typeId: Scalars['String']['input'];
};

export type MeterReadingType = {
  __typename?: 'MeterReadingType';
  /** Reading */
  reading?: Maybe<Scalars['Int']['output']>;
  /** Reading date */
  readingDate: Scalars['DateTimeOffset']['output'];
};

export type MeterType = {
  __typename?: 'MeterType';
  currentReading?: Maybe<MeterReadingType>;
  /** Is Meter on contract */
  isOnContract?: Maybe<Scalars['Boolean']['output']>;
  /** MeterReading name */
  name?: Maybe<Scalars['String']['output']>;
  previousReading?: Maybe<MeterReadingType>;
  /** Meter type id */
  typeId?: Maybe<Scalars['String']['output']>;
  /** For Evatic meters validation, usual increase number per day */
  unitsPerDay?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderLineInfoType = {
  __typename?: 'OrderLineInfoType';
  info01?: Maybe<BasicDataType>;
  info01Values?: Maybe<BasicDataType>;
  info02?: Maybe<BasicDataType>;
  info02Values?: Maybe<BasicDataType>;
  info03?: Maybe<BasicDataType>;
  info03Values?: Maybe<BasicDataType>;
  info04?: Maybe<BasicDataType>;
  info04Values?: Maybe<BasicDataType>;
};

export type PartInputType = {
  articleNo: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  info01?: InputMaybe<Scalars['String']['input']>;
  info02?: InputMaybe<Scalars['String']['input']>;
  info03?: InputMaybe<Scalars['String']['input']>;
  info04?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  isNonStock?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  salesPrice?: InputMaybe<Scalars['Decimal']['input']>;
  salesPriceChangedOnClient?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PartStatus>;
  stockId: Scalars['String']['input'];
  stockStore?: InputMaybe<StockStore>;
};

export type PartQueryInputType = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  stockStore?: InputMaybe<StockStore>;
};

export enum PartStatus {
  Requested = 'REQUESTED',
  RequestedReturned = 'REQUESTED_RETURNED',
  RequestedUsed = 'REQUESTED_USED',
  Used = 'USED'
}

export type PartType = {
  __typename?: 'PartType';
  /** The article no of the Part */
  articleNo?: Maybe<Scalars['String']['output']>;
  /** Evatic Supplier article no */
  articleNoSupplier?: Maybe<Scalars['String']['output']>;
  /** The search name of the part */
  articleSearchName?: Maybe<Scalars['String']['output']>;
  /** The barcode number of the part */
  barcode?: Maybe<Scalars['String']['output']>;
  /** The description of the part */
  description?: Maybe<Scalars['String']['output']>;
  info01?: Maybe<Scalars['String']['output']>;
  info02?: Maybe<Scalars['String']['output']>;
  info03?: Maybe<Scalars['String']['output']>;
  info04?: Maybe<Scalars['String']['output']>;
  /** Invoice type */
  invoiceType?: Maybe<Scalars['String']['output']>;
  /** Is part non-stock */
  isNonStock?: Maybe<Scalars['Boolean']['output']>;
  /** Location of part */
  location?: Maybe<Scalars['String']['output']>;
  /** DEPRECATED: The article no of the Part */
  partNumber?: Maybe<Scalars['String']['output']>;
  /** Quantity in stock */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  /** Sales Price */
  salesPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Sales price changed by client */
  salesPriceChangedOnClient?: Maybe<Scalars['Boolean']['output']>;
  /** Evatic Sort Group 1 code */
  sortGroup1?: Maybe<Scalars['String']['output']>;
  /** Evatic Sort Group 2 code */
  sortGroup2?: Maybe<Scalars['String']['output']>;
  /** Evatic Sort Group 3 code */
  sortGroup3?: Maybe<Scalars['String']['output']>;
  /** Evatic Sort Group 4 code */
  sortGroup4?: Maybe<Scalars['String']['output']>;
  /** Evatic Sort Group 5 code */
  sortGroup5?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PartStatus>;
  /** Stock id */
  stockId?: Maybe<Scalars['String']['output']>;
  /** Stock name */
  stockName?: Maybe<Scalars['String']['output']>;
  stockStore?: Maybe<StockStore>;
  storeLabel?: Maybe<Scalars['String']['output']>;
  /** Evatic Supplier Guid */
  supplierId?: Maybe<Scalars['String']['output']>;
  /** Evatic Supplier name */
  supplierName?: Maybe<Scalars['String']['output']>;
  /** Evatic Supplier no */
  supplierNo?: Maybe<Scalars['String']['output']>;
};

export type PartnerJobInfoType = {
  __typename?: 'PartnerJobInfoType';
  jobId: Scalars['String']['output'];
  user?: Maybe<PartnerUserType>;
};

export type PartnerUserType = {
  __typename?: 'PartnerUserType';
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  stockId?: Maybe<Scalars['String']['output']>;
  technicianGuid?: Maybe<Scalars['ID']['output']>;
  technicianId: Scalars['String']['output'];
  technicianNo: Scalars['String']['output'];
};

export type PlannerFilterInputType = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  engineerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  plannerNode?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  responseDate?: InputMaybe<Scalars['DateTime']['input']>;
  symptomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PlannerNodesType = {
  __typename?: 'PlannerNodesType';
  isVirtualNode?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  nodeKey?: Maybe<Scalars['String']['output']>;
  nodeParent?: Maybe<Scalars['String']['output']>;
  nodeText?: Maybe<Scalars['String']['output']>;
};

export type PreLoginResult = {
  __typename?: 'PreLoginResult';
  /** Audience for this user auth0 login */
  audience?: Maybe<Scalars['String']['output']>;
  /** ClientId for this user auth0 login */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Domain for this user auth0 login */
  domain?: Maybe<Scalars['String']['output']>;
  /** The email of the user */
  email: Scalars['String']['output'];
  /** Url for this user auth0 login */
  url?: Maybe<Scalars['String']['output']>;
};

export type PropertyValueInputType = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  propertyGuid?: InputMaybe<Scalars['String']['input']>;
  sourceGuid?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  areas: Array<AreaType>;
  availabilityTypes: Array<AvailabilityType>;
  calendar: CalendarType;
  checklistGroups: Array<ChecklistGroupsType>;
  commentMentionables?: Maybe<CommentMentionablesType>;
  commentNotifications: Array<CommentNotificationType>;
  comments: Array<CommentType>;
  contacts: Array<ContactType>;
  createJobOptions?: Maybe<JobOptionsType>;
  customer?: Maybe<CustomerType>;
  customerByMachine?: Maybe<CustomerType>;
  customers: Array<CustomerType>;
  databaseCheck?: Maybe<DatabaseCheckType>;
  extras: Array<ExtraType>;
  featureFlags: Array<FeatureFlagType>;
  files: Array<FileType>;
  job?: Maybe<ServiceJob>;
  jobActions: Array<ActionType>;
  jobPlanner: Array<ServiceJob>;
  jobVisits: Array<ServiceJob>;
  jobVisitsHistory: Array<ServiceJob>;
  jobs: Array<ServiceJob>;
  jobsPlanner: Array<ServiceJob>;
  machines: Array<MachineType>;
  orderLineInfo: OrderLineInfoType;
  partSortGroups: SortGroupsType;
  partnerData?: Maybe<PartnerJobInfoType>;
  parts: Array<PartType>;
  plannerNodes: Array<PlannerNodesType>;
  preOrderedParts: Array<PartType>;
  publicFeatureFlags: Array<FeatureFlagType>;
  requestableParts: Array<PartType>;
  serviceHistory: Array<ServiceHistory>;
  stockEnquiry: Array<PartType>;
  stockList: Array<Stock>;
  suggestedParts: Array<Scalars['String']['output']>;
  suppliers: Array<SupplierType>;
  symptoms: Array<JobSymptomType>;
  technicianHistory: Array<ServiceJob>;
  technicianSettings: TechnicianSettings;
  technicians: Array<TechnicianType>;
  userEndpoints: UserEndpointResult;
  userSettings: UserSettings;
  workNotes: Array<WorkNoteType>;
};


export type QueryChecklistGroupsArgs = {
  machineId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommentsArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerArgs = {
  nameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerByMachineArgs = {
  machineGuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomersArgs = {
  nameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilesArgs = {
  jobId: Scalars['ID']['input'];
  max?: Scalars['Int']['input'];
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobActionsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobPlannerArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobVisitsArgs = {
  jobId: Scalars['ID']['input'];
  max?: Scalars['Int']['input'];
};


export type QueryJobVisitsHistoryArgs = {
  jobId: Scalars['ID']['input'];
  max?: Scalars['Int']['input'];
};


export type QueryJobsArgs = {
  jobFilter?: InputMaybe<JobFilterInputType>;
  max?: Scalars['Int']['input'];
};


export type QueryJobsPlannerArgs = {
  plannerFilter?: InputMaybe<PlannerFilterInputType>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMachinesArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  machineNo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartsArgs = {
  location: PartQueryInputType;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreOrderedPartsArgs = {
  count: Scalars['Int']['input'];
  jobId: Scalars['String']['input'];
};


export type QueryServiceHistoryArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  machineId?: InputMaybe<Scalars['String']['input']>;
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStockEnquiryArgs = {
  hideOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuggestedPartsArgs = {
  machineId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTechnicianHistoryArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserEndpointsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkNotesArgs = {
  jobId: Scalars['ID']['input'];
};

export enum QuestionDataType {
  Boolean = 'Boolean',
  ConditionalGroup = 'ConditionalGroup',
  Date = 'Date',
  DateTime = 'DateTime',
  Decimal = 'Decimal',
  DropDown = 'DropDown',
  Expression = 'Expression',
  Group = 'Group',
  Image = 'Image',
  Int32 = 'Int32',
  Signature = 'Signature',
  String = 'String',
  TimeOfDay = 'TimeOfDay'
}

export type SalesTaskType = {
  __typename?: 'SalesTaskType';
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  itemGuid?: Maybe<Scalars['ID']['output']>;
  projectNo?: Maybe<Scalars['Int']['output']>;
  projectTaskAssignmentId?: Maybe<Scalars['Int']['output']>;
  taskNo?: Maybe<Scalars['Int']['output']>;
  taskSubject?: Maybe<Scalars['String']['output']>;
  taskText?: Maybe<Scalars['String']['output']>;
};

export type ServiceHistory = {
  __typename?: 'ServiceHistory';
  actionCodes: Array<Scalars['String']['output']>;
  completedDate: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  lastStatusName?: Maybe<Scalars['String']['output']>;
  machine?: Maybe<MachineType>;
  priority?: Maybe<Scalars['String']['output']>;
  projectTaskId?: Maybe<Scalars['Int']['output']>;
  receivedDate: Scalars['String']['output'];
  responseDate: Scalars['DateTimeOffset']['output'];
  serviceJobId?: Maybe<Scalars['String']['output']>;
  symptomDescription?: Maybe<Scalars['String']['output']>;
  symptoms: Array<Scalars['String']['output']>;
  taskCreator?: Maybe<Scalars['String']['output']>;
  technicianName: Scalars['String']['output'];
  workEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceJob = {
  __typename?: 'ServiceJob';
  /** The action taken to solve the service job */
  actions: Array<ActionType>;
  checklists: Array<ChecklistType>;
  /** The date the service job was marked as completed */
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  contract?: Maybe<ContractType>;
  coordinates?: Maybe<CoordinatesType>;
  /** The customer the service job is for */
  customer?: Maybe<CustomerType>;
  /** Image data of the customer's signature */
  customerSignatureImageData?: Maybe<Scalars['String']['output']>;
  /** The name of the customer signing off the visit */
  customerSignerName?: Maybe<Scalars['String']['output']>;
  /** Id in source system this service job is from */
  externalId: Scalars['String']['output'];
  /** The id of the job. */
  id: Scalars['String']['output'];
  machine?: Maybe<MachineType>;
  meters: Array<MeterType>;
  /** The planned date of the service job */
  plannedDate?: Maybe<TimesType>;
  preOrderedParts: Array<PartType>;
  preferredContact?: Maybe<CustomerContactType>;
  /** The priority of the service job */
  priority?: Maybe<Scalars['String']['output']>;
  /** The priority code of the service job */
  priorityCode?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The response target date of the service job */
  responseDate?: Maybe<Scalars['DateTime']['output']>;
  /** Technician notes on the solution for the service job */
  solutionDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<JobStatus>;
  /** Service job symptom description */
  symptomDescription?: Maybe<Scalars['String']['output']>;
  symptoms: Array<Scalars['String']['output']>;
  taskCreator?: Maybe<Scalars['String']['output']>;
  /** The id of technician */
  technicianId?: Maybe<Scalars['String']['output']>;
  /** The name of technician */
  technicianName?: Maybe<Scalars['String']['output']>;
  /** Image data of the technician's signature */
  technicianSignatureImageData?: Maybe<Scalars['String']['output']>;
  /** Travel times list with start and end dates */
  travelTimes: Array<TimesType>;
  usedParts: Array<PartType>;
  /** Work times list with start and end dates */
  workTimes: Array<TimesType>;
};

export type SortGroupValueType = {
  __typename?: 'SortGroupValueType';
  description: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SortGroupsType = {
  __typename?: 'SortGroupsType';
  sortGroup1?: Maybe<BasicDataType>;
  sortGroup1Values?: Maybe<Array<BasicDataType>>;
  sortGroup2?: Maybe<BasicDataType>;
  sortGroup2Values?: Maybe<Array<BasicDataType>>;
  sortGroup3?: Maybe<BasicDataType>;
  sortGroup3Values?: Maybe<Array<BasicDataType>>;
  sortGroup4?: Maybe<BasicDataType>;
  sortGroup4Values?: Maybe<Array<BasicDataType>>;
  sortGroup5?: Maybe<BasicDataType>;
  sortGroup5Values?: Maybe<Array<BasicDataType>>;
};

export type Stock = {
  __typename?: 'Stock';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum StockStore {
  Engineer = 'ENGINEER',
  Locational = 'LOCATIONAL',
  Nonstock = 'NONSTOCK',
  Other = 'OTHER'
}

export type SupplierType = {
  __typename?: 'SupplierType';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  supplierNo: Scalars['String']['output'];
};

export type SyncMobileStockInputType = {
  articleNo: Scalars['String']['input'];
  moveToTechnicianGuid?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Decimal']['input'];
};

export enum TaskStatus {
  Accepted = 'Accepted',
  Assigned = 'Assigned',
  Callback = 'Callback',
  Deleted = 'Deleted',
  Done = 'Done',
  Downloaded = 'Downloaded',
  None = 'NONE',
  Rejected = 'Rejected',
  Returned = 'Returned'
}

export type TechnicianAvailabilityType = {
  __typename?: 'TechnicianAvailabilityType';
  availNo?: Maybe<Scalars['Int']['output']>;
  availabilityType?: Maybe<Scalars['String']['output']>;
  barText?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
};

export type TechnicianSettings = {
  __typename?: 'TechnicianSettings';
  actionCodeStrongRelation: Scalars['Boolean']['output'];
  advancedPlannerAccess: Scalars['Boolean']['output'];
  allowChangeInvoiceType: Scalars['Boolean']['output'];
  allowEditMachineInstallDate: Scalars['Boolean']['output'];
  allowEditTimes: Scalars['Boolean']['output'];
  allowMoveStock: Scalars['Boolean']['output'];
  allowNegativeStock: Scalars['Boolean']['output'];
  allowOrderStock: Scalars['Boolean']['output'];
  allowUpdateStock: Scalars['Boolean']['output'];
  canCreateJob: Scalars['Boolean']['output'];
  customerSatisfactionEnabled: Scalars['Boolean']['output'];
  isAllowedMobileMachineEdit: Scalars['Boolean']['output'];
  mapboxToken: Scalars['String']['output'];
  requireActionCode1: Scalars['Boolean']['output'];
  requireActionCode2: Scalars['Boolean']['output'];
  requireActionCode3: Scalars['Boolean']['output'];
  requireActionText: Scalars['Boolean']['output'];
  requireActionTextReturn: Scalars['Boolean']['output'];
  requireCheckListId: Scalars['Boolean']['output'];
  requireCustomerSignature: Scalars['Boolean']['output'];
  requireCustomerSignatureName: Scalars['Boolean']['output'];
  requireMeterReading: Scalars['Boolean']['output'];
  requireReference: Scalars['Boolean']['output'];
  requireSymptomCode1: Scalars['Boolean']['output'];
  requireSymptomCode2: Scalars['Boolean']['output'];
  requireSymptomCode3: Scalars['Boolean']['output'];
  requireSymtomText: Scalars['Boolean']['output'];
  requireTechnicianSignature: Scalars['Boolean']['output'];
  requireTravelTime: Scalars['Boolean']['output'];
  requireTravelTimeReturn: Scalars['Boolean']['output'];
  requireWorkTime: Scalars['Boolean']['output'];
  requireWorkTimeReturn: Scalars['Boolean']['output'];
  requiredSolutionDescription: Scalars['Boolean']['output'];
  sendMailToCustomer: Scalars['Boolean']['output'];
  simplePlannerAccess: Scalars['Boolean']['output'];
  storeSignaturesLocal: Scalars['Boolean']['output'];
  symptomCodeStrongRelation: Scalars['Boolean']['output'];
  syncCostPrice: Scalars['Boolean']['output'];
  syncSalesPrice: Scalars['Boolean']['output'];
  workTimeEnd: Scalars['String']['output'];
  workTimeStart: Scalars['String']['output'];
};

export type TechnicianTeamType = {
  __typename?: 'TechnicianTeamType';
  teamCode: Scalars['String']['output'];
  teamDescription?: Maybe<Scalars['String']['output']>;
  teamGuid: Scalars['ID']['output'];
};

export type TechnicianType = {
  __typename?: 'TechnicianType';
  guid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TimesInputType = {
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  /** Times object start time */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Times object stop time */
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimesType = {
  __typename?: 'TimesType';
  invoiceType?: Maybe<Scalars['String']['output']>;
  /** Times object start time */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** Times object stop time */
  stopTime?: Maybe<Scalars['DateTime']['output']>;
  uploaded?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAvailabilityInputType = {
  availNo?: InputMaybe<Scalars['Int']['input']>;
  availabilityType?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMachineInputType = {
  addressRowNo?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  idNo?: InputMaybe<Scalars['String']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  installDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  machineNo?: InputMaybe<Scalars['String']['input']>;
  modelGuid: Scalars['String']['input'];
};

export type UpdateVisitInputType = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobVisit?: InputMaybe<JobVisitInput>;
  taskStatus?: InputMaybe<TaskStatus>;
};

export type UpdateVisitResponse = {
  __typename?: 'UpdateVisitResponse';
  errorInfo?: Maybe<Scalars['String']['output']>;
  errorKey?: Maybe<Scalars['String']['output']>;
  /** The id of the job. */
  id: Scalars['String']['output'];
  /** Response log */
  responseLog: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UserConsentInputType = {
  accepted: Scalars['Boolean']['input'];
  type: UserConsentTypeEnum;
  version: Scalars['Int']['input'];
};

export type UserConsentType = {
  __typename?: 'UserConsentType';
  accepted: Scalars['Boolean']['output'];
  type: UserConsentTypeEnum;
  version: Scalars['Int']['output'];
};

export enum UserConsentTypeEnum {
  Basic = 'Basic',
  Tracking = 'Tracking',
  Userpilot = 'Userpilot'
}

export type UserEndpointResult = {
  __typename?: 'UserEndpointResult';
  email: Scalars['String']['output'];
  lastEndpoint?: Maybe<Endpoint>;
  useMultipleEndpoints: Scalars['Boolean']['output'];
  userEndpoints: Array<Endpoint>;
};

export type UserMentionType = {
  __typename?: 'UserMentionType';
  fullName?: Maybe<Scalars['String']['output']>;
  loginName?: Maybe<Scalars['String']['output']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  email: Scalars['String']['output'];
  lastEndpoint?: Maybe<Endpoint>;
  useMultipleEndpoints: Scalars['Boolean']['output'];
  userEndpoints: Array<Endpoint>;
};

export type UserSettingsInputType = {
  lastEndpoint?: InputMaybe<EndpointInputType>;
  useMultipleEndpoints?: InputMaybe<Scalars['Boolean']['input']>;
  userEndpoints: Array<EndpointInputType>;
};

export type WorkNoteInputType = {
  loggedBy: Scalars['String']['input'];
  loggedDate: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
};

export type WorkNoteType = {
  __typename?: 'WorkNoteType';
  hideHeader?: Maybe<Scalars['Boolean']['output']>;
  loggedBy: Scalars['String']['output'];
  loggedDate: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
};

export type ChecklistFragmentFragment = { __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> };

export type EndpointFragmentFragment = { __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string };

export type JobFragmentFragment = { __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> };

export type LoginFragmentFragment = { __typename: 'LoginResult', id: string, expiry: string, token: string, email: string, technicianId: string, languageCode?: string | null | undefined, stockId?: string | null | undefined, technicianGuid?: string | null | undefined, fullName?: string | null | undefined, companyName?: string | null | undefined, technicianNo?: string | null | undefined, userConsents: Array<{ __typename?: 'UserConsentType', accepted: boolean, version: number, type: UserConsentTypeEnum }> };

export type AddChecklistMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  checklistCode: Scalars['String']['input'];
}>;


export type AddChecklistMutation = { __typename?: 'AsolviMobileMutation', addChecklist?: { __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> } | null | undefined };

export type AddUserConsentMutationVariables = Exact<{
  userConsents: Array<UserConsentInputType> | UserConsentInputType;
}>;


export type AddUserConsentMutation = { __typename?: 'AsolviMobileMutation', addUserConsent: Array<{ __typename?: 'UserConsentType', accepted: boolean, version: number, type: UserConsentTypeEnum }> };

export type AddWorkNoteMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobId: Scalars['String']['input'];
  workNote: WorkNoteInputType;
}>;


export type AddWorkNoteMutation = { __typename?: 'AsolviMobileMutation', addWorkNote?: { __typename?: 'WorkNoteType', loggedDate: string, loggedBy: string, text: string } | null | undefined };

export type AssignTaskMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  technicianId: Scalars['String']['input'];
  scheduleStartDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AssignTaskMutation = { __typename?: 'AsolviMobileMutation', assignTask?: boolean | null | undefined };

export type Auth0LoginMutationVariables = Exact<{
  url: Scalars['String']['input'];
  email: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type Auth0LoginMutation = { __typename?: 'AsolviMobileMutation', auth0Login?: { __typename: 'LoginResult', id: string, expiry: string, token: string, email: string, technicianId: string, languageCode?: string | null | undefined, stockId?: string | null | undefined, technicianGuid?: string | null | undefined, fullName?: string | null | undefined, companyName?: string | null | undefined, technicianNo?: string | null | undefined, userConsents: Array<{ __typename?: 'UserConsentType', accepted: boolean, version: number, type: UserConsentTypeEnum }> } | null | undefined };

export type ChangeJobMachineMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobId: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
}>;


export type ChangeJobMachineMutation = { __typename?: 'AsolviMobileMutation', changeJobMachine?: boolean | null | undefined };

export type CreateJobMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobDetails: JobInputType;
  files: Array<FileInputType> | FileInputType;
}>;


export type CreateJobMutation = { __typename?: 'AsolviMobileMutation', createServiceJob?: { __typename?: 'CreateJobResult', jobId?: string | null | undefined } | null | undefined };

export type DeleteCommentMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  commentId: Scalars['Int']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'AsolviMobileMutation', deleteComment?: boolean | null | undefined };

export type EditContactMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
  contact: ContactInputType;
}>;


export type EditContactMutation = { __typename?: 'AsolviMobileMutation', updateContact?: boolean | null | undefined };

export type InsertCommentMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  comment: CommentInputType;
}>;


export type InsertCommentMutation = { __typename?: 'AsolviMobileMutation', insertComment?: number | null | undefined };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'AsolviMobileMutation', logout?: { __typename?: 'LogoutResult', message: string } | null | undefined };

export type MarkCommentNotificationReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MarkCommentNotificationReadMutation = { __typename?: 'AsolviMobileMutation', markCommentNotificationRead?: boolean | null | undefined };

export type OrderMobileStockMutationVariables = Exact<{
  stocks: Array<SyncMobileStockInputType> | SyncMobileStockInputType;
}>;


export type OrderMobileStockMutation = { __typename?: 'AsolviMobileMutation', orderMobileStock?: boolean | null | undefined };

export type PreLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type PreLoginMutation = { __typename?: 'AsolviMobileMutation', preLogin?: { __typename?: 'PreLoginResult', email: string, url?: string | null | undefined, clientId?: string | null | undefined, domain?: string | null | undefined, audience?: string | null | undefined } | null | undefined };

export type RejectJobAssignmentMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobId: Scalars['String']['input'];
  rejectReason: Scalars['String']['input'];
}>;


export type RejectJobAssignmentMutation = { __typename?: 'AsolviMobileMutation', rejectJobAssignment?: boolean | null | undefined };

export type SendRemoteAccessEmailMutationVariables = Exact<{
  peerId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type SendRemoteAccessEmailMutation = { __typename?: 'AsolviMobileMutation', sendRemoteAccessEmail?: boolean | null | undefined };

export type SyncMobileStockMutationVariables = Exact<{
  stocks: Array<SyncMobileStockInputType> | SyncMobileStockInputType;
}>;


export type SyncMobileStockMutation = { __typename?: 'AsolviMobileMutation', syncMobileStock?: boolean | null | undefined };

export type UpdateAvailabilityMutationVariables = Exact<{
  availability: UpdateAvailabilityInputType;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'AsolviMobileMutation', updateAvailability?: boolean | null | undefined };

export type UpdateCommentMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  comment: CommentInputType;
}>;


export type UpdateCommentMutation = { __typename?: 'AsolviMobileMutation', updateComment?: boolean | null | undefined };

export type UpdateJobStatusMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  status: JobStatus;
}>;


export type UpdateJobStatusMutation = { __typename?: 'AsolviMobileMutation', updateJobStatus?: { __typename?: 'ServiceJob', id: string, status?: JobStatus | null | undefined } | null | undefined };

export type UpdateJobsStatusMutationVariables = Exact<{
  jobIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  status: JobStatus;
}>;


export type UpdateJobsStatusMutation = { __typename?: 'AsolviMobileMutation', updateJobsStatus?: boolean | null | undefined };

export type UpdateMachineLocationMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  machine: UpdateMachineInputType;
  jobId: Scalars['String']['input'];
}>;


export type UpdateMachineLocationMutation = { __typename?: 'AsolviMobileMutation', updateMachineLocation?: boolean | null | undefined };

export type UpdateMachineInstallDateMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  machine: UpdateMachineInputType;
  jobId: Scalars['String']['input'];
}>;


export type UpdateMachineInstallDateMutation = { __typename?: 'AsolviMobileMutation', updateMachineInstallDate?: boolean | null | undefined };

export type UpdateMachineCustomPropertiesMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  properties: Array<PropertyValueInputType> | PropertyValueInputType;
}>;


export type UpdateMachineCustomPropertiesMutation = { __typename?: 'AsolviMobileMutation', updateMachineCustomProperties?: { __typename: 'ServiceJob', id: string, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMetersMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  meters: Array<MeterReadingInputType> | MeterReadingInputType;
  jobId: Scalars['String']['input'];
}>;


export type UpdateMetersMutation = { __typename?: 'AsolviMobileMutation', updateMeters?: boolean | null | undefined };

export type UpdatePlannedDateMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  times: TimesInputType;
}>;


export type UpdatePlannedDateMutation = { __typename?: 'AsolviMobileMutation', updatePlannedDate?: boolean | null | undefined };

export type UpdateTechStatusMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  jobId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateTechStatusMutation = { __typename?: 'AsolviMobileMutation', updateTechStatus?: boolean | null | undefined };

export type UpdateTechnicianMetadataMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
}>;


export type UpdateTechnicianMetadataMutation = { __typename?: 'AsolviMobileMutation', updateTechnicianMetadata?: boolean | null | undefined };

export type UpdateUserSettingsMutationVariables = Exact<{
  userSettings?: InputMaybe<UserSettingsInputType>;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'AsolviMobileMutation', userSettings: { __typename?: 'UserSettings', email: string, useMultipleEndpoints: boolean, lastEndpoint?: { __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string } | null | undefined, userEndpoints: Array<{ __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string }> } };

export type UpdateVisitWithPartsMutationVariables = Exact<{
  metadata?: InputMaybe<MetadataInputType>;
  updateVisit: UpdateVisitInputType;
}>;


export type UpdateVisitWithPartsMutation = { __typename?: 'AsolviMobileMutation', updateVisitWithParts?: { __typename?: 'UpdateVisitResponse', id: string, success: boolean, responseLog: string, errorKey?: string | null | undefined, errorInfo?: string | null | undefined } | null | undefined };

export type UploadFileMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  file: FileInputType;
}>;


export type UploadFileMutation = { __typename?: 'AsolviMobileMutation', uploadFile?: boolean | null | undefined };

export type GetAvailablePartsQueryVariables = Exact<{
  location: PartQueryInputType;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAvailablePartsQuery = { __typename?: 'Query', parts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, isNonStock?: boolean | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined, sortGroup1?: string | null | undefined, sortGroup2?: string | null | undefined, sortGroup3?: string | null | undefined, sortGroup4?: string | null | undefined, sortGroup5?: string | null | undefined, supplierId?: string | null | undefined, supplierName?: string | null | undefined, supplierNo?: string | null | undefined, salesPrice?: number | null | undefined, articleSearchName?: string | null | undefined, articleNoSupplier?: string | null | undefined }> };

export type GetCachePrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCachePrefillQuery = { __typename?: 'Query', extras: Array<{ __typename?: 'ExtraType', id: string, code: string, company: string, department: string, isTime: boolean, quantity: number, servicesCode: string, type: string, sortNo?: number | null | undefined }>, jobActions: Array<{ __typename?: 'ActionType', name?: string | null | undefined, code?: string | null | undefined, id?: string | null | undefined, sortId?: string | null | undefined, subActionCodes?: Array<string> | null | undefined }>, symptoms: Array<{ __typename?: 'JobSymptomType', code?: string | null | undefined, description?: string | null | undefined, sortId?: string | null | undefined, subSymptomCodes?: Array<string> | null | undefined }>, suppliers: Array<{ __typename?: 'SupplierType', id: string, name?: string | null | undefined, supplierNo: string }>, availabilityTypes: Array<{ __typename?: 'AvailabilityType', code?: string | null | undefined, description?: string | null | undefined, sortId?: string | null | undefined }>, partSortGroups: { __typename?: 'SortGroupsType', sortGroup1?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup1Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup2?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup2Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup3?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup3Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup4?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup4Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup5?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup5Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined }, orderLineInfo: { __typename?: 'OrderLineInfoType', info01?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info01Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info02?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info02Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info03?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info03Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info04?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info04Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined } };

export type GetPartnerCachePrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerCachePrefillQuery = { __typename?: 'Query', extras: Array<{ __typename?: 'ExtraType', id: string, code: string, company: string, department: string, isTime: boolean, quantity: number, servicesCode: string, type: string }>, jobActions: Array<{ __typename?: 'ActionType', name?: string | null | undefined, code?: string | null | undefined, id?: string | null | undefined, sortId?: string | null | undefined, subActionCodes?: Array<string> | null | undefined }>, symptoms: Array<{ __typename?: 'JobSymptomType', code?: string | null | undefined, description?: string | null | undefined, sortId?: string | null | undefined, subSymptomCodes?: Array<string> | null | undefined }>, suppliers: Array<{ __typename?: 'SupplierType', id: string, name?: string | null | undefined, supplierNo: string }>, partSortGroups: { __typename?: 'SortGroupsType', sortGroup1?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup1Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup2?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup2Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup3?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup3Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup4?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup4Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, sortGroup5?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, sortGroup5Values?: Array<{ __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> | null | undefined }, orderLineInfo: { __typename?: 'OrderLineInfoType', info01?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info01Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info02?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info02Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info03?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info03Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info04?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined, info04Values?: { __typename?: 'BasicDataType', type?: string | null | undefined, sortId?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined } | null | undefined } };

export type GetCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarQuery = { __typename?: 'Query', calendar: { __typename?: 'CalendarType', availability: Array<{ __typename?: 'TechnicianAvailabilityType', availNo?: number | null | undefined, barText?: string | null | undefined, availabilityType?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, color?: string | null | undefined }>, salesTasks: Array<{ __typename?: 'SalesTaskType', projectNo?: number | null | undefined, taskNo?: number | null | undefined, projectTaskAssignmentId?: number | null | undefined, taskSubject?: string | null | undefined, taskText?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, itemGuid?: string | null | undefined }>, projectTasks: Array<{ __typename?: 'CalendarProjectTaskType', projectNo?: number | null | undefined, taskNo?: number | null | undefined, externalId?: string | null | undefined, projectTaskAssignmentId?: number | null | undefined, addressName?: string | null | undefined, actionText?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, itemGuid?: string | null | undefined }> } };

export type GetChecklistGroupsQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChecklistGroupsQuery = { __typename?: 'Query', checklistGroups: Array<{ __typename?: 'ChecklistGroupsType', company?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined }> };

export type GetCommentMentionablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommentMentionablesQuery = { __typename?: 'Query', commentMentionables?: { __typename?: 'CommentMentionablesType', defaultMainServiceTeam: boolean, defaultTaskCreator: boolean, mainServiceTeamCode?: string | null | undefined, teams?: Array<{ __typename?: 'TechnicianTeamType', teamCode: string, teamDescription?: string | null | undefined, teamGuid: string }> | null | undefined, technicians?: Array<{ __typename?: 'TechnicianType', id: string, name?: string | null | undefined, guid: string }> | null | undefined, users?: Array<{ __typename?: 'UserMentionType', fullName?: string | null | undefined, loginName?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetCommentNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommentNotificationsQuery = { __typename?: 'Query', commentNotifications: Array<{ __typename?: 'CommentNotificationType', notificationId: number, commentId: number, sourceGuid: string, source: string, sourceIdText: string, createdDate?: string | null | undefined, notificationRead?: boolean | null | undefined, commentText: string, commentOwnerFullName: string, commentCreatedDate?: string | null | undefined, commentChangedDate?: string | null | undefined, jobId?: string | null | undefined, assignedTechnicianId?: string | null | undefined }> };

export type GetCommentsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'CommentType', commentId: number, sourceGuid: string, owner: string, ownerFullName?: string | null | undefined, createdDate?: string | null | undefined, changedDate?: string | null | undefined, fullAccess?: boolean | null | undefined, text?: string | null | undefined }> };

export type GetContactsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'ContactType', id: string, name: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, mobile?: string | null | undefined, contactNo?: string | null | undefined }> };

export type GetCreateJobOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateJobOptionsQuery = { __typename?: 'Query', createJobOptions?: { __typename?: 'JobOptionsType', symptoms: Array<{ __typename?: 'JobSymptomType', code?: string | null | undefined, description?: string | null | undefined, sortId?: string | null | undefined, subSymptomCodes?: Array<string> | null | undefined }> } | null | undefined };

export type GetCustomersQueryVariables = Exact<{
  nameFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'CustomerType', id: string, name?: string | null | undefined, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename?: 'CustomerContactType', id: string, name?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, email?: string | null | undefined }> }> };

export type GetCustomersSimpleQueryVariables = Exact<{
  nameFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomersSimpleQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'CustomerType', id: string, name?: string | null | undefined, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined }> };

export type GetCustomerQueryVariables = Exact<{
  nameFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerType', id: string, name?: string | null | undefined, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename?: 'CustomerContactType', id: string, name?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, email?: string | null | undefined }> } | null | undefined };

export type GetCustomerByMachineQueryVariables = Exact<{
  machineGuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerByMachineQuery = { __typename?: 'Query', customerByMachine?: { __typename?: 'CustomerType', id: string, name?: string | null | undefined, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename?: 'CustomerContactType', id: string, name?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, email?: string | null | undefined }> } | null | undefined };

export type GetFilesQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetFilesQuery = { __typename?: 'Query', files: Array<{ __typename?: 'FileType', id: string, fileGuid?: string | null | undefined, data: string, description?: string | null | undefined, name: string, size?: number | null | undefined, fileType: string, useInServiceReport?: boolean | null | undefined }> };

export type GetTechnicianHistoryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetTechnicianHistoryQuery = { __typename?: 'Query', technicianHistory: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetServiceHistoryQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceHistoryQuery = { __typename?: 'Query', serviceHistory: Array<{ __typename?: 'ServiceHistory', serviceJobId?: string | null | undefined, responseDate: string, completedDate: string, receivedDate: string, projectTaskId?: number | null | undefined, lastStatusName?: string | null | undefined, technicianName: string, customerName: string, actionCodes: Array<string>, symptoms: Array<string>, priority?: string | null | undefined, externalId?: string | null | undefined, symptomDescription?: string | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, machineNo?: string | null | undefined } | null | undefined }> };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> } | null | undefined };

export type GetJobPlannerQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetJobPlannerQuery = { __typename?: 'Query', jobPlanner: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetJobVisitsQueryVariables = Exact<{
  max: Scalars['Int']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type GetJobVisitsQuery = { __typename?: 'Query', jobVisits: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetJobVisitsHistoryQueryVariables = Exact<{
  max: Scalars['Int']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type GetJobVisitsHistoryQuery = { __typename?: 'Query', jobVisitsHistory: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetJobsQueryVariables = Exact<{
  max: Scalars['Int']['input'];
  jobFilter?: InputMaybe<JobFilterInputType>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetJobsPlannerQueryVariables = Exact<{
  plannerFilter?: InputMaybe<PlannerFilterInputType>;
}>;


export type GetJobsPlannerQuery = { __typename?: 'Query', jobsPlanner: Array<{ __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> }> };

export type GetMachinesQueryVariables = Exact<{
  machineNo?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMachinesQuery = { __typename?: 'Query', machines: Array<{ __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, increaseLimit?: number | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, location?: string | null | undefined, customerId?: string | null | undefined, customerName?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined }> };

export type GetPartnerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerDataQuery = { __typename?: 'Query', partnerData?: { __typename?: 'PartnerJobInfoType', jobId: string, user?: { __typename?: 'PartnerUserType', companyName: string, email: string, fullName: string, stockId?: string | null | undefined, technicianGuid?: string | null | undefined, technicianId: string, technicianNo: string } | null | undefined } | null | undefined };

export type GetPermissionSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionSettingsQuery = { __typename?: 'Query', featureFlags: Array<{ __typename?: 'FeatureFlagType', name: string, isActive: boolean }>, technicianSettings: { __typename?: 'TechnicianSettings', allowChangeInvoiceType: boolean, allowNegativeStock: boolean, allowEditMachineInstallDate: boolean, allowMoveStock: boolean, allowOrderStock: boolean, allowUpdateStock: boolean, syncSalesPrice: boolean, syncCostPrice: boolean, isAllowedMobileMachineEdit: boolean, canCreateJob: boolean, simplePlannerAccess: boolean, advancedPlannerAccess: boolean, requiredSolutionDescription: boolean, sendMailToCustomer: boolean, mapboxToken: string, requireActionCode1: boolean, requireActionCode2: boolean, requireActionCode3: boolean, requireActionText: boolean, requireActionTextReturn: boolean, requireCheckListId: boolean, requireMeterReading: boolean, requireReference: boolean, requireSymptomCode1: boolean, requireSymptomCode2: boolean, requireSymptomCode3: boolean, requireCustomerSignature: boolean, requireCustomerSignatureName: boolean, requireTechnicianSignature: boolean, requireSymtomText: boolean, requireTravelTime: boolean, requireTravelTimeReturn: boolean, requireWorkTime: boolean, requireWorkTimeReturn: boolean, customerSatisfactionEnabled: boolean, storeSignaturesLocal: boolean, workTimeStart: string, workTimeEnd: string, actionCodeStrongRelation: boolean, symptomCodeStrongRelation: boolean, allowEditTimes: boolean } };

export type GetPlannerCachePrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannerCachePrefillQuery = { __typename?: 'Query', areas: Array<{ __typename?: 'AreaType', id: string, areaCode: string, description: string, technicians: Array<string> }>, plannerNodes: Array<{ __typename?: 'PlannerNodesType', nodeKey?: string | null | undefined, nodeText?: string | null | undefined, nodeParent?: string | null | undefined, isVirtualNode?: boolean | null | undefined, label?: string | null | undefined }>, symptoms: Array<{ __typename?: 'JobSymptomType', code?: string | null | undefined, description?: string | null | undefined, sortId?: string | null | undefined }> };

export type GetPublicFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicFeatureFlagsQuery = { __typename?: 'Query', publicFeatureFlags: Array<{ __typename?: 'FeatureFlagType', name: string, isActive: boolean }> };

export type GetRequestablePartsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestablePartsQuery = { __typename?: 'Query', requestableParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, isNonStock?: boolean | null | undefined, stockName?: string | null | undefined, sortGroup1?: string | null | undefined, sortGroup2?: string | null | undefined, sortGroup3?: string | null | undefined, sortGroup4?: string | null | undefined, sortGroup5?: string | null | undefined, supplierId?: string | null | undefined, supplierName?: string | null | undefined, supplierNo?: string | null | undefined, salesPrice?: number | null | undefined, articleSearchName?: string | null | undefined, articleNoSupplier?: string | null | undefined }> };

export type GetPreOrderedPartsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
  count: Scalars['Int']['input'];
}>;


export type GetPreOrderedPartsQuery = { __typename?: 'Query', preOrderedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, isNonStock?: boolean | null | undefined, stockName?: string | null | undefined, salesPrice?: number | null | undefined }> };

export type GetStockEnquiryQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  hideOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStockEnquiryQuery = { __typename?: 'Query', stockEnquiry: Array<{ __typename?: 'PartType', barcode?: string | null | undefined, description?: string | null | undefined, isNonStock?: boolean | null | undefined, articleNo?: string | null | undefined, quantity?: number | null | undefined, status?: PartStatus | null | undefined, stockId?: string | null | undefined, stockName?: string | null | undefined, stockStore?: StockStore | null | undefined, location?: string | null | undefined }> };

export type GetStockListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockListQuery = { __typename?: 'Query', stockList: Array<{ __typename?: 'Stock', id: string, name: string }> };

export type GetSuggestedPartsQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSuggestedPartsQuery = { __typename?: 'Query', suggestedParts: Array<string> };

export type GetTechniciansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTechniciansQuery = { __typename?: 'Query', technicians: Array<{ __typename?: 'TechnicianType', id: string, name?: string | null | undefined, guid: string }> };

export type GetUserEndpointsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserEndpointsQuery = { __typename?: 'Query', userEndpoints: { __typename?: 'UserEndpointResult', email: string, useMultipleEndpoints: boolean, lastEndpoint?: { __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string } | null | undefined, userEndpoints: Array<{ __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string }> } };

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'Query', userSettings: { __typename: 'UserSettings', email: string, useMultipleEndpoints: boolean, lastEndpoint?: { __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string } | null | undefined, userEndpoints: Array<{ __typename: 'Endpoint', id: string, apiUrl: string, apiVersion: string }> } };

export type GetWorkNotesQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetWorkNotesQuery = { __typename?: 'Query', workNotes: Array<{ __typename?: 'WorkNoteType', loggedDate: string, loggedBy: string, text: string, hideHeader?: boolean | null | undefined }> };

export type RefreshJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type RefreshJobQuery = { __typename?: 'Query', job?: { __typename: 'ServiceJob', status?: JobStatus | null | undefined, id: string, technicianId?: string | null | undefined, technicianName?: string | null | undefined, externalId: string, responseDate?: string | null | undefined, symptomDescription?: string | null | undefined, symptoms: Array<string>, priority?: string | null | undefined, priorityCode?: string | null | undefined, completedDate?: string | null | undefined, receivedDate?: string | null | undefined, taskCreator?: string | null | undefined, solutionDescription?: string | null | undefined, customerSignerName?: string | null | undefined, plannedDate?: { __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined } | null | undefined, contract?: { __typename?: 'ContractType', typeObjNo?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, validTo?: string | null | undefined, terminationDate?: string | null | undefined } | null | undefined, machine?: { __typename?: 'MachineType', id?: string | null | undefined, name?: string | null | undefined, location?: string | null | undefined, idNo?: string | null | undefined, machineNo?: string | null | undefined, modelGuid?: string | null | undefined, addressRowNo?: number | null | undefined, increaseLimit?: number | null | undefined, installDate?: string | null | undefined, servicesCode?: string | null | undefined, details?: { __typename?: 'MachineDetailsType', information?: string | null | undefined, customProperties?: Array<{ __typename?: 'CustomPropertyType', code: string, description: string, value?: string | null | undefined, propertyGuid?: string | null | undefined, sourceGuid?: string | null | undefined, type: string }> | null | undefined, sortGroups?: Array<{ __typename?: 'SortGroupValueType', description: string, value?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined, travelTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, usedParts: Array<{ __typename?: 'PartType', description?: string | null | undefined, articleNo?: string | null | undefined, barcode?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, preOrderedParts: Array<{ __typename?: 'PartType', articleNo?: string | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, quantity?: number | null | undefined, stockStore?: StockStore | null | undefined, status?: PartStatus | null | undefined, stockName?: string | null | undefined, stockId?: string | null | undefined }>, actions: Array<{ __typename: 'ActionType', id?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, sortId?: string | null | undefined }>, workTimes: Array<{ __typename?: 'TimesType', startTime?: string | null | undefined, stopTime?: string | null | undefined }>, coordinates?: { __typename?: 'CoordinatesType', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, customer?: { __typename: 'CustomerType', name?: string | null | undefined, id: string, isOnStop: boolean, customerNo?: string | null | undefined, address?: { __typename?: 'AddressType', name?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, address3?: string | null | undefined, postalCode?: string | null | undefined, postalPlace?: string | null | undefined, country?: string | null | undefined, city?: string | null | undefined } | null | undefined, contacts: Array<{ __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }> } | null | undefined, preferredContact?: { __typename: 'CustomerContactType', name?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, mobileNumber?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, meters: Array<{ __typename?: 'MeterType', name?: string | null | undefined, typeId?: string | null | undefined, unitsPerDay?: number | null | undefined, isOnContract?: boolean | null | undefined, currentReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined, previousReading?: { __typename?: 'MeterReadingType', reading?: number | null | undefined, readingDate: string } | null | undefined }>, checklists: Array<{ __typename?: 'ChecklistType', checklistCode?: string | null | undefined, title: string, description?: string | null | undefined, isTemplate?: boolean | null | undefined, machineGuid?: string | null | undefined, questions: Array<{ __typename?: 'ChecklistQuestionType', nodeKey?: string | null | undefined, question: string, dataType: QuestionDataType, isRequired: boolean, isRequiredPreStart: boolean, answer?: string | null | undefined, minValue?: number | null | undefined, maxValue?: number | null | undefined, showComment: boolean, comment?: string | null | undefined, parent?: string | null | undefined, showCondition?: boolean | null | undefined, dropDownValues: Array<string>, expression?: string | null | undefined, expressionParams: Array<{ __typename?: 'ExpressionParameterType', key: string, description?: string | null | undefined, value?: number | null | undefined }> }> }> } | null | undefined, files: Array<{ __typename?: 'FileType', id: string, data: string, description?: string | null | undefined, name: string, size?: number | null | undefined, fileType: string }>, workNotes: Array<{ __typename?: 'WorkNoteType', loggedDate: string, loggedBy: string, text: string, hideHeader?: boolean | null | undefined }> };

export const ChecklistFragmentFragmentDoc = gql`
    fragment ChecklistFragment on ChecklistType {
  checklistCode
  title
  description
  isTemplate
  machineGuid
  questions {
    nodeKey
    question
    dataType
    isRequired
    isRequiredPreStart
    answer
    minValue
    maxValue
    showComment
    comment
    parent
    showCondition
    dropDownValues
    expression
    expressionParams {
      key
      description
      value
    }
  }
}
    `;
export const EndpointFragmentFragmentDoc = gql`
    fragment EndpointFragment on Endpoint {
  __typename
  id
  apiUrl
  apiVersion
}
    `;
export const JobFragmentFragmentDoc = gql`
    fragment JobFragment on ServiceJob {
  __typename
  status
  id
  technicianId
  technicianName
  externalId
  responseDate
  plannedDate {
    startTime
    stopTime
  }
  symptomDescription
  symptoms
  priority
  priorityCode
  contract {
    typeObjNo
    code
    description
    validTo
    terminationDate
  }
  completedDate
  receivedDate
  taskCreator
  machine {
    id
    name
    location
    idNo
    machineNo
    modelGuid
    addressRowNo
    increaseLimit
    installDate
    servicesCode
    details {
      information
      customProperties {
        code
        description
        value
        propertyGuid
        sourceGuid
        type
      }
      sortGroups {
        description
        value
      }
    }
  }
  travelTimes {
    startTime
    stopTime
  }
  usedParts {
    description
    articleNo
    barcode
    quantity
    stockStore
    status
    stockName
    stockId
  }
  preOrderedParts {
    articleNo
    barcode
    description
    quantity
    stockStore
    status
    stockName
    stockId
  }
  actions {
    __typename
    id
    name
    code
    sortId
  }
  workTimes {
    startTime
    stopTime
  }
  solutionDescription
  customerSignerName
  coordinates {
    latitude
    longitude
  }
  customer {
    __typename
    name
    id
    isOnStop
    customerNo
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
    contacts {
      __typename
      name
      email
      phoneNumber
      mobileNumber
      id
      firstName
      lastName
    }
  }
  preferredContact {
    __typename
    name
    email
    phoneNumber
    mobileNumber
    id
    firstName
    lastName
  }
  meters {
    name
    typeId
    unitsPerDay
    isOnContract
    currentReading {
      reading
      readingDate
    }
    previousReading {
      reading
      readingDate
    }
  }
  checklists {
    checklistCode
    title
    description
    isTemplate
    machineGuid
    questions {
      nodeKey
      question
      dataType
      isRequired
      isRequiredPreStart
      answer
      minValue
      maxValue
      showComment
      comment
      parent
      showCondition
      dropDownValues
      expression
      expressionParams {
        key
        description
        value
      }
    }
  }
}
    `;
export const LoginFragmentFragmentDoc = gql`
    fragment LoginFragment on LoginResult {
  __typename
  id
  expiry
  token
  email
  technicianId
  languageCode
  stockId
  technicianGuid
  fullName
  companyName
  technicianNo
  userConsents {
    accepted
    version
    type
  }
}
    `;
export const AddChecklistDocument = gql`
    mutation addChecklist($jobId: String!, $checklistCode: String!) {
  addChecklist(jobId: $jobId, checklistCode: $checklistCode) {
    ...ChecklistFragment
  }
}
    ${ChecklistFragmentFragmentDoc}`;
export const AddUserConsentDocument = gql`
    mutation addUserConsent($userConsents: [UserConsentInputType!]!) {
  addUserConsent(userConsents: $userConsents) {
    accepted
    version
    type
  }
}
    `;
export const AddWorkNoteDocument = gql`
    mutation addWorkNote($metadata: MetadataInputType, $jobId: String!, $workNote: WorkNoteInputType!) {
  addWorkNote(metadata: $metadata, jobId: $jobId, workNote: $workNote) {
    loggedDate
    loggedBy
    text
  }
}
    `;
export const AssignTaskDocument = gql`
    mutation assignTask($jobId: String!, $technicianId: String!, $scheduleStartDate: DateTime) {
  assignTask(
    jobId: $jobId
    technicianId: $technicianId
    scheduleStartDate: $scheduleStartDate
  )
}
    `;
export const Auth0LoginDocument = gql`
    mutation auth0Login($url: String!, $email: String!, $accessToken: String!, $refreshToken: String) {
  auth0Login(
    url: $url
    email: $email
    accessToken: $accessToken
    refreshToken: $refreshToken
  ) {
    ...LoginFragment
  }
}
    ${LoginFragmentFragmentDoc}`;
export const ChangeJobMachineDocument = gql`
    mutation changeJobMachine($metadata: MetadataInputType, $jobId: String!, $machineId: String!) {
  changeJobMachine(metadata: $metadata, jobId: $jobId, machineId: $machineId)
}
    `;
export const CreateJobDocument = gql`
    mutation createJob($metadata: MetadataInputType, $jobDetails: JobInputType!, $files: [FileInputType!]!) {
  createServiceJob(metadata: $metadata, jobDetails: $jobDetails, files: $files) {
    jobId
  }
}
    `;
export const DeleteCommentDocument = gql`
    mutation deleteComment($metadata: MetadataInputType, $commentId: Int!) {
  deleteComment(metadata: $metadata, commentId: $commentId)
}
    `;
export const EditContactDocument = gql`
    mutation editContact($metadata: MetadataInputType, $jobId: String!, $customerId: String!, $machineId: String!, $contact: ContactInputType!) {
  updateContact(
    metadata: $metadata
    jobId: $jobId
    customerId: $customerId
    machineId: $machineId
    contact: $contact
  )
}
    `;
export const InsertCommentDocument = gql`
    mutation insertComment($metadata: MetadataInputType, $comment: CommentInputType!) {
  insertComment(metadata: $metadata, comment: $comment)
}
    `;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    message
  }
}
    `;
export const MarkCommentNotificationReadDocument = gql`
    mutation markCommentNotificationRead($notificationIds: [Int!]!) {
  markCommentNotificationRead(notificationIds: $notificationIds)
}
    `;
export const OrderMobileStockDocument = gql`
    mutation orderMobileStock($stocks: [SyncMobileStockInputType!]!) {
  orderMobileStock(stocks: $stocks)
}
    `;
export const PreLoginDocument = gql`
    mutation preLogin($email: String!, $url: String!) {
  preLogin(email: $email, url: $url) {
    email
    url
    clientId
    domain
    audience
  }
}
    `;
export const RejectJobAssignmentDocument = gql`
    mutation rejectJobAssignment($metadata: MetadataInputType, $jobId: String!, $rejectReason: String!) {
  rejectJobAssignment(
    metadata: $metadata
    jobId: $jobId
    rejectReason: $rejectReason
  )
}
    `;
export const SendRemoteAccessEmailDocument = gql`
    mutation sendRemoteAccessEmail($peerId: String!, $jobId: String!, $email: String!) {
  sendRemoteAccessEmail(peerId: $peerId, jobId: $jobId, email: $email)
}
    `;
export const SyncMobileStockDocument = gql`
    mutation syncMobileStock($stocks: [SyncMobileStockInputType!]!) {
  syncMobileStock(stocks: $stocks)
}
    `;
export const UpdateAvailabilityDocument = gql`
    mutation updateAvailability($availability: UpdateAvailabilityInputType!) {
  updateAvailability(availability: $availability)
}
    `;
export const UpdateCommentDocument = gql`
    mutation updateComment($metadata: MetadataInputType, $comment: CommentInputType!) {
  updateComment(metadata: $metadata, comment: $comment)
}
    `;
export const UpdateJobStatusDocument = gql`
    mutation updateJobStatus($jobId: String!, $status: JobStatus!) {
  updateJobStatus(jobId: $jobId, status: $status) {
    id
    status
  }
}
    `;
export const UpdateJobsStatusDocument = gql`
    mutation updateJobsStatus($jobIds: [String!]!, $status: JobStatus!) {
  updateJobsStatus(jobIds: $jobIds, status: $status)
}
    `;
export const UpdateMachineLocationDocument = gql`
    mutation updateMachineLocation($metadata: MetadataInputType, $machine: UpdateMachineInputType!, $jobId: String!) {
  updateMachineLocation(metadata: $metadata, machine: $machine, jobId: $jobId)
}
    `;
export const UpdateMachineInstallDateDocument = gql`
    mutation updateMachineInstallDate($metadata: MetadataInputType, $machine: UpdateMachineInputType!, $jobId: String!) {
  updateMachineInstallDate(metadata: $metadata, machine: $machine, jobId: $jobId)
}
    `;
export const UpdateMachineCustomPropertiesDocument = gql`
    mutation updateMachineCustomProperties($jobId: String!, $properties: [PropertyValueInputType!]!) {
  updateMachineCustomProperties(jobId: $jobId, properties: $properties) {
    __typename
    id
    machine {
      id
      name
      location
      idNo
      machineNo
      modelGuid
      addressRowNo
      increaseLimit
      installDate
      details {
        customProperties {
          code
          description
          value
          propertyGuid
          sourceGuid
          type
        }
        sortGroups {
          description
          value
        }
      }
    }
  }
}
    `;
export const UpdateMetersDocument = gql`
    mutation updateMeters($metadata: MetadataInputType, $meters: [MeterReadingInputType!]!, $jobId: String!) {
  updateMeters(metadata: $metadata, meters: $meters, jobId: $jobId)
}
    `;
export const UpdatePlannedDateDocument = gql`
    mutation updatePlannedDate($jobId: String!, $times: TimesInputType!) {
  updatePlannedDate(jobId: $jobId, times: $times)
}
    `;
export const UpdateTechStatusDocument = gql`
    mutation updateTechStatus($metadata: MetadataInputType, $jobId: String!, $status: String!) {
  updateTechStatus(metadata: $metadata, jobId: $jobId, status: $status)
}
    `;
export const UpdateTechnicianMetadataDocument = gql`
    mutation updateTechnicianMetadata($metadata: MetadataInputType) {
  updateTechnicianMetadata(metadata: $metadata)
}
    `;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($userSettings: UserSettingsInputType) {
  userSettings(userSettings: $userSettings) {
    email
    useMultipleEndpoints
    lastEndpoint {
      ...EndpointFragment
    }
    userEndpoints {
      ...EndpointFragment
    }
  }
}
    ${EndpointFragmentFragmentDoc}`;
export const UpdateVisitWithPartsDocument = gql`
    mutation updateVisitWithParts($metadata: MetadataInputType, $updateVisit: UpdateVisitInputType!) {
  updateVisitWithParts(metadata: $metadata, updateVisit: $updateVisit) {
    id
    success
    responseLog
    errorKey
    errorInfo
  }
}
    `;
export const UploadFileDocument = gql`
    mutation uploadFile($jobId: String!, $file: FileInputType!) {
  uploadFile(jobId: $jobId, file: $file)
}
    `;
export const GetAvailablePartsDocument = gql`
    query getAvailableParts($location: PartQueryInputType!, $searchString: String) {
  parts(location: $location, searchString: $searchString) {
    description
    articleNo
    barcode
    quantity
    stockStore
    isNonStock
    stockName
    stockId
    sortGroup1
    sortGroup2
    sortGroup3
    sortGroup4
    sortGroup5
    supplierId
    supplierName
    supplierNo
    salesPrice
    articleSearchName
    articleNoSupplier
  }
}
    `;
export const GetCachePrefillDocument = gql`
    query getCachePrefill {
  extras {
    id
    code
    company
    department
    isTime
    quantity
    servicesCode
    type
    sortNo
  }
  jobActions(max: 300) {
    name
    code
    id
    sortId
    subActionCodes
  }
  symptoms {
    code
    description
    sortId
    subSymptomCodes
  }
  suppliers {
    id
    name
    supplierNo
  }
  availabilityTypes {
    code
    description
    sortId
  }
  partSortGroups {
    sortGroup1 {
      type
      sortId
      code
      description
    }
    sortGroup1Values {
      type
      sortId
      code
      description
    }
    sortGroup2 {
      type
      sortId
      code
      description
    }
    sortGroup2Values {
      type
      sortId
      code
      description
    }
    sortGroup3 {
      type
      sortId
      code
      description
    }
    sortGroup3Values {
      type
      sortId
      code
      description
    }
    sortGroup4 {
      type
      sortId
      code
      description
    }
    sortGroup4Values {
      type
      sortId
      code
      description
    }
    sortGroup5 {
      type
      sortId
      code
      description
    }
    sortGroup5Values {
      type
      sortId
      code
      description
    }
  }
  orderLineInfo {
    info01 {
      type
      sortId
      code
      description
    }
    info01Values {
      type
      sortId
      code
      description
    }
    info02 {
      type
      sortId
      code
      description
    }
    info02Values {
      type
      sortId
      code
      description
    }
    info03 {
      type
      sortId
      code
      description
    }
    info03Values {
      type
      sortId
      code
      description
    }
    info04 {
      type
      sortId
      code
      description
    }
    info04Values {
      type
      sortId
      code
      description
    }
  }
}
    `;
export const GetPartnerCachePrefillDocument = gql`
    query getPartnerCachePrefill {
  extras {
    id
    code
    company
    department
    isTime
    quantity
    servicesCode
    type
  }
  jobActions(max: 300) {
    name
    code
    id
    sortId
    subActionCodes
  }
  symptoms {
    code
    description
    sortId
    subSymptomCodes
  }
  suppliers {
    id
    name
    supplierNo
  }
  partSortGroups {
    sortGroup1 {
      type
      sortId
      code
      description
    }
    sortGroup1Values {
      type
      sortId
      code
      description
    }
    sortGroup2 {
      type
      sortId
      code
      description
    }
    sortGroup2Values {
      type
      sortId
      code
      description
    }
    sortGroup3 {
      type
      sortId
      code
      description
    }
    sortGroup3Values {
      type
      sortId
      code
      description
    }
    sortGroup4 {
      type
      sortId
      code
      description
    }
    sortGroup4Values {
      type
      sortId
      code
      description
    }
    sortGroup5 {
      type
      sortId
      code
      description
    }
    sortGroup5Values {
      type
      sortId
      code
      description
    }
  }
  orderLineInfo {
    info01 {
      type
      sortId
      code
      description
    }
    info01Values {
      type
      sortId
      code
      description
    }
    info02 {
      type
      sortId
      code
      description
    }
    info02Values {
      type
      sortId
      code
      description
    }
    info03 {
      type
      sortId
      code
      description
    }
    info03Values {
      type
      sortId
      code
      description
    }
    info04 {
      type
      sortId
      code
      description
    }
    info04Values {
      type
      sortId
      code
      description
    }
  }
}
    `;
export const GetCalendarDocument = gql`
    query getCalendar {
  calendar {
    availability {
      availNo
      barText
      availabilityType
      dateFrom
      dateTo
      color
    }
    salesTasks {
      projectNo
      taskNo
      projectTaskAssignmentId
      taskSubject
      taskText
      dateFrom
      dateTo
      itemGuid
    }
    projectTasks {
      projectNo
      taskNo
      externalId
      projectTaskAssignmentId
      addressName
      actionText
      dateFrom
      dateTo
      itemGuid
    }
  }
}
    `;
export const GetChecklistGroupsDocument = gql`
    query getChecklistGroups($machineId: String) {
  checklistGroups(machineId: $machineId) {
    company
    code
    description
  }
}
    `;
export const GetCommentMentionablesDocument = gql`
    query getCommentMentionables {
  commentMentionables {
    teams {
      teamCode
      teamDescription
      teamGuid
    }
    technicians {
      id
      name
      guid
    }
    users {
      fullName
      loginName
    }
    defaultMainServiceTeam
    defaultTaskCreator
    mainServiceTeamCode
  }
}
    `;
export const GetCommentNotificationsDocument = gql`
    query getCommentNotifications {
  commentNotifications {
    notificationId
    commentId
    sourceGuid
    source
    sourceIdText
    createdDate
    notificationRead
    commentText
    commentOwnerFullName
    commentCreatedDate
    commentChangedDate
    jobId
    assignedTechnicianId
  }
}
    `;
export const GetCommentsDocument = gql`
    query getComments($jobId: ID!) {
  comments(jobId: $jobId) {
    commentId
    sourceGuid
    owner
    ownerFullName
    createdDate
    changedDate
    fullAccess
    text
  }
}
    `;
export const GetContactsDocument = gql`
    query getContacts($customerId: String!) {
  contacts(customerId: $customerId) {
    id
    name
    email
    firstName
    lastName
    phone
    mobile
    contactNo
  }
}
    `;
export const GetCreateJobOptionsDocument = gql`
    query getCreateJobOptions {
  createJobOptions {
    symptoms {
      code
      description
      sortId
      subSymptomCodes
    }
  }
}
    `;
export const GetCustomersDocument = gql`
    query getCustomers($nameFilter: String) {
  customers(nameFilter: $nameFilter) {
    id
    name
    isOnStop
    customerNo
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
    contacts {
      id
      name
      phoneNumber
      mobileNumber
      email
    }
  }
}
    `;
export const GetCustomersSimpleDocument = gql`
    query getCustomersSimple($nameFilter: String) {
  customers(nameFilter: $nameFilter) {
    id
    name
    customerNo
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
  }
}
    `;
export const GetCustomerDocument = gql`
    query getCustomer($nameFilter: String) {
  customer(nameFilter: $nameFilter) {
    id
    name
    isOnStop
    customerNo
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
    contacts {
      id
      name
      phoneNumber
      mobileNumber
      email
    }
  }
}
    `;
export const GetCustomerByMachineDocument = gql`
    query getCustomerByMachine($machineGuid: String) {
  customerByMachine(machineGuid: $machineGuid) {
    id
    name
    isOnStop
    customerNo
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
    contacts {
      id
      name
      phoneNumber
      mobileNumber
      email
    }
  }
}
    `;
export const GetFilesDocument = gql`
    query getFiles($jobId: ID!) {
  files(jobId: $jobId) {
    id
    fileGuid
    data
    description
    name
    size
    fileType
    useInServiceReport
  }
}
    `;
export const GetTechnicianHistoryDocument = gql`
    query getTechnicianHistory($from: DateTime, $specificDate: DateTime) {
  technicianHistory(from: $from, specificDate: $specificDate) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetServiceHistoryDocument = gql`
    query getServiceHistory($machineId: String, $fromDate: DateTime, $specificDate: DateTime, $customerId: String) {
  serviceHistory(
    machineId: $machineId
    fromDate: $fromDate
    specificDate: $specificDate
    customerId: $customerId
  ) {
    serviceJobId
    responseDate
    completedDate
    receivedDate
    projectTaskId
    lastStatusName
    technicianName
    customerName
    actionCodes
    symptoms
    priority
    externalId
    symptomDescription
    machine {
      id
      name
      location
      machineNo
    }
  }
}
    `;
export const GetJobDocument = gql`
    query getJob($id: ID!) {
  job(id: $id) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetJobPlannerDocument = gql`
    query getJobPlanner($jobId: String!) {
  jobPlanner(jobId: $jobId) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetJobVisitsDocument = gql`
    query getJobVisits($max: Int!, $jobId: ID!) {
  jobVisits(max: $max, jobId: $jobId) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetJobVisitsHistoryDocument = gql`
    query getJobVisitsHistory($max: Int!, $jobId: ID!) {
  jobVisitsHistory(max: $max, jobId: $jobId) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetJobsDocument = gql`
    query getJobs($max: Int!, $jobFilter: JobFilterInputType) {
  jobs(max: $max, jobFilter: $jobFilter) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetJobsPlannerDocument = gql`
    query getJobsPlanner($plannerFilter: PlannerFilterInputType) {
  jobsPlanner(plannerFilter: $plannerFilter) {
    ...JobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export const GetMachinesDocument = gql`
    query getMachines($machineNo: String, $customerId: String) {
  machines(machineNo: $machineNo, customerId: $customerId) {
    id
    name
    increaseLimit
    idNo
    machineNo
    location
    customerId
    customerName
    address {
      name
      address1
      address2
      address3
      postalCode
      postalPlace
      country
      city
    }
  }
}
    `;
export const GetPartnerDataDocument = gql`
    query getPartnerData {
  partnerData {
    jobId
    user {
      companyName
      email
      fullName
      stockId
      technicianGuid
      technicianId
      technicianNo
    }
  }
}
    `;
export const GetPermissionSettingsDocument = gql`
    query getPermissionSettings {
  featureFlags {
    name
    isActive
  }
  technicianSettings {
    allowChangeInvoiceType
    allowNegativeStock
    allowEditMachineInstallDate
    allowMoveStock
    allowOrderStock
    allowUpdateStock
    syncSalesPrice
    syncCostPrice
    isAllowedMobileMachineEdit
    canCreateJob
    simplePlannerAccess
    advancedPlannerAccess
    requiredSolutionDescription
    sendMailToCustomer
    mapboxToken
    requireActionCode1
    requireActionCode2
    requireActionCode3
    requireActionText
    requireActionTextReturn
    requireCheckListId
    requireMeterReading
    requireReference
    requireSymptomCode1
    requireSymptomCode2
    requireSymptomCode3
    requireCustomerSignature
    requireCustomerSignatureName
    requireTechnicianSignature
    requireSymtomText
    requireTravelTime
    requireTravelTimeReturn
    requireWorkTime
    requireWorkTimeReturn
    customerSatisfactionEnabled
    storeSignaturesLocal
    workTimeStart
    workTimeEnd
    actionCodeStrongRelation
    symptomCodeStrongRelation
    allowEditTimes
  }
}
    `;
export const GetPlannerCachePrefillDocument = gql`
    query getPlannerCachePrefill {
  areas {
    id
    areaCode
    description
    technicians
  }
  plannerNodes {
    nodeKey
    nodeText
    nodeParent
    isVirtualNode
    label
  }
  symptoms {
    code
    description
    sortId
  }
}
    `;
export const GetPublicFeatureFlagsDocument = gql`
    query getPublicFeatureFlags {
  publicFeatureFlags {
    name
    isActive
  }
}
    `;
export const GetRequestablePartsDocument = gql`
    query getRequestableParts {
  requestableParts {
    description
    articleNo
    barcode
    quantity
    stockStore
    isNonStock
    stockName
    sortGroup1
    sortGroup2
    sortGroup3
    sortGroup4
    sortGroup5
    supplierId
    supplierName
    supplierNo
    salesPrice
    articleSearchName
    articleNoSupplier
  }
}
    `;
export const GetPreOrderedPartsDocument = gql`
    query getPreOrderedParts($jobId: String!, $count: Int!) {
  preOrderedParts(jobId: $jobId, count: $count) {
    description
    articleNo
    barcode
    quantity
    stockStore
    isNonStock
    stockName
    salesPrice
  }
}
    `;
export const GetStockEnquiryDocument = gql`
    query getStockEnquiry($locationId: String, $searchString: String, $hideOutOfStock: Boolean) {
  stockEnquiry(
    locationId: $locationId
    searchString: $searchString
    hideOutOfStock: $hideOutOfStock
  ) {
    barcode
    description
    isNonStock
    articleNo
    quantity
    status
    stockId
    stockName
    stockStore
    location
  }
}
    `;
export const GetStockListDocument = gql`
    query getStockList {
  stockList {
    id
    name
  }
}
    `;
export const GetSuggestedPartsDocument = gql`
    query getSuggestedParts($machineId: String) {
  suggestedParts(machineId: $machineId)
}
    `;
export const GetTechniciansDocument = gql`
    query getTechnicians {
  technicians {
    id
    name
    guid
  }
}
    `;
export const GetUserEndpointsDocument = gql`
    query getUserEndpoints($email: String!) {
  userEndpoints(email: $email) {
    email
    useMultipleEndpoints
    lastEndpoint {
      ...EndpointFragment
    }
    userEndpoints {
      ...EndpointFragment
    }
  }
}
    ${EndpointFragmentFragmentDoc}`;
export const GetUserSettingsDocument = gql`
    query getUserSettings {
  userSettings {
    __typename
    email
    useMultipleEndpoints
    lastEndpoint {
      ...EndpointFragment
    }
    userEndpoints {
      ...EndpointFragment
    }
  }
}
    ${EndpointFragmentFragmentDoc}`;
export const GetWorkNotesDocument = gql`
    query getWorkNotes($jobId: ID!) {
  workNotes(jobId: $jobId) {
    loggedDate
    loggedBy
    text
    hideHeader
  }
}
    `;
export const RefreshJobDocument = gql`
    query refreshJob($jobId: ID!) {
  job(id: $jobId) {
    ...JobFragment
  }
  files(jobId: $jobId) {
    id
    data
    description
    name
    size
    fileType
  }
  workNotes(jobId: $jobId) {
    loggedDate
    loggedBy
    text
    hideHeader
  }
}
    ${JobFragmentFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addChecklist(variables: AddChecklistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddChecklistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddChecklistMutation>(AddChecklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addChecklist', 'mutation');
    },
    addUserConsent(variables: AddUserConsentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserConsentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserConsentMutation>(AddUserConsentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserConsent', 'mutation');
    },
    addWorkNote(variables: AddWorkNoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddWorkNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddWorkNoteMutation>(AddWorkNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addWorkNote', 'mutation');
    },
    assignTask(variables: AssignTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignTaskMutation>(AssignTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignTask', 'mutation');
    },
    auth0Login(variables: Auth0LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Auth0LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Auth0LoginMutation>(Auth0LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'auth0Login', 'mutation');
    },
    changeJobMachine(variables: ChangeJobMachineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeJobMachineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeJobMachineMutation>(ChangeJobMachineDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeJobMachine', 'mutation');
    },
    createJob(variables: CreateJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobMutation>(CreateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJob', 'mutation');
    },
    deleteComment(variables: DeleteCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCommentMutation>(DeleteCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteComment', 'mutation');
    },
    editContact(variables: EditContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditContactMutation>(EditContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editContact', 'mutation');
    },
    insertComment(variables: InsertCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InsertCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertCommentMutation>(InsertCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertComment', 'mutation');
    },
    logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout', 'mutation');
    },
    markCommentNotificationRead(variables: MarkCommentNotificationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkCommentNotificationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkCommentNotificationReadMutation>(MarkCommentNotificationReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markCommentNotificationRead', 'mutation');
    },
    orderMobileStock(variables: OrderMobileStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderMobileStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderMobileStockMutation>(OrderMobileStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderMobileStock', 'mutation');
    },
    preLogin(variables: PreLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreLoginMutation>(PreLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'preLogin', 'mutation');
    },
    rejectJobAssignment(variables: RejectJobAssignmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectJobAssignmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectJobAssignmentMutation>(RejectJobAssignmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectJobAssignment', 'mutation');
    },
    sendRemoteAccessEmail(variables: SendRemoteAccessEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendRemoteAccessEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendRemoteAccessEmailMutation>(SendRemoteAccessEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendRemoteAccessEmail', 'mutation');
    },
    syncMobileStock(variables: SyncMobileStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncMobileStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncMobileStockMutation>(SyncMobileStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'syncMobileStock', 'mutation');
    },
    updateAvailability(variables: UpdateAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAvailabilityMutation>(UpdateAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAvailability', 'mutation');
    },
    updateComment(variables: UpdateCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCommentMutation>(UpdateCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateComment', 'mutation');
    },
    updateJobStatus(variables: UpdateJobStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateJobStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateJobStatusMutation>(UpdateJobStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateJobStatus', 'mutation');
    },
    updateJobsStatus(variables: UpdateJobsStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateJobsStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateJobsStatusMutation>(UpdateJobsStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateJobsStatus', 'mutation');
    },
    updateMachineLocation(variables: UpdateMachineLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMachineLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMachineLocationMutation>(UpdateMachineLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMachineLocation', 'mutation');
    },
    updateMachineInstallDate(variables: UpdateMachineInstallDateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMachineInstallDateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMachineInstallDateMutation>(UpdateMachineInstallDateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMachineInstallDate', 'mutation');
    },
    updateMachineCustomProperties(variables: UpdateMachineCustomPropertiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMachineCustomPropertiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMachineCustomPropertiesMutation>(UpdateMachineCustomPropertiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMachineCustomProperties', 'mutation');
    },
    updateMeters(variables: UpdateMetersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMetersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMetersMutation>(UpdateMetersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMeters', 'mutation');
    },
    updatePlannedDate(variables: UpdatePlannedDateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePlannedDateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePlannedDateMutation>(UpdatePlannedDateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePlannedDate', 'mutation');
    },
    updateTechStatus(variables: UpdateTechStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTechStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTechStatusMutation>(UpdateTechStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTechStatus', 'mutation');
    },
    updateTechnicianMetadata(variables?: UpdateTechnicianMetadataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTechnicianMetadataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTechnicianMetadataMutation>(UpdateTechnicianMetadataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTechnicianMetadata', 'mutation');
    },
    updateUserSettings(variables?: UpdateUserSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserSettingsMutation>(UpdateUserSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserSettings', 'mutation');
    },
    updateVisitWithParts(variables: UpdateVisitWithPartsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVisitWithPartsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVisitWithPartsMutation>(UpdateVisitWithPartsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVisitWithParts', 'mutation');
    },
    uploadFile(variables: UploadFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileMutation>(UploadFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFile', 'mutation');
    },
    getAvailableParts(variables: GetAvailablePartsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAvailablePartsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAvailablePartsQuery>(GetAvailablePartsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAvailableParts', 'query');
    },
    getCachePrefill(variables?: GetCachePrefillQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCachePrefillQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCachePrefillQuery>(GetCachePrefillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCachePrefill', 'query');
    },
    getPartnerCachePrefill(variables?: GetPartnerCachePrefillQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPartnerCachePrefillQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerCachePrefillQuery>(GetPartnerCachePrefillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartnerCachePrefill', 'query');
    },
    getCalendar(variables?: GetCalendarQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCalendarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCalendarQuery>(GetCalendarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCalendar', 'query');
    },
    getChecklistGroups(variables?: GetChecklistGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetChecklistGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChecklistGroupsQuery>(GetChecklistGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChecklistGroups', 'query');
    },
    getCommentMentionables(variables?: GetCommentMentionablesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCommentMentionablesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommentMentionablesQuery>(GetCommentMentionablesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCommentMentionables', 'query');
    },
    getCommentNotifications(variables?: GetCommentNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCommentNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommentNotificationsQuery>(GetCommentNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCommentNotifications', 'query');
    },
    getComments(variables: GetCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommentsQuery>(GetCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getComments', 'query');
    },
    getContacts(variables: GetContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContactsQuery>(GetContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getContacts', 'query');
    },
    getCreateJobOptions(variables?: GetCreateJobOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCreateJobOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCreateJobOptionsQuery>(GetCreateJobOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCreateJobOptions', 'query');
    },
    getCustomers(variables?: GetCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomersQuery>(GetCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomers', 'query');
    },
    getCustomersSimple(variables?: GetCustomersSimpleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomersSimpleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomersSimpleQuery>(GetCustomersSimpleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomersSimple', 'query');
    },
    getCustomer(variables?: GetCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomerQuery>(GetCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomer', 'query');
    },
    getCustomerByMachine(variables?: GetCustomerByMachineQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomerByMachineQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomerByMachineQuery>(GetCustomerByMachineDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomerByMachine', 'query');
    },
    getFiles(variables: GetFilesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFilesQuery>(GetFilesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFiles', 'query');
    },
    getTechnicianHistory(variables?: GetTechnicianHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTechnicianHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTechnicianHistoryQuery>(GetTechnicianHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTechnicianHistory', 'query');
    },
    getServiceHistory(variables?: GetServiceHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetServiceHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetServiceHistoryQuery>(GetServiceHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getServiceHistory', 'query');
    },
    getJob(variables: GetJobQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobQuery>(GetJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJob', 'query');
    },
    getJobPlanner(variables: GetJobPlannerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobPlannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobPlannerQuery>(GetJobPlannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobPlanner', 'query');
    },
    getJobVisits(variables: GetJobVisitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobVisitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobVisitsQuery>(GetJobVisitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobVisits', 'query');
    },
    getJobVisitsHistory(variables: GetJobVisitsHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobVisitsHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobVisitsHistoryQuery>(GetJobVisitsHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobVisitsHistory', 'query');
    },
    getJobs(variables: GetJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobsQuery>(GetJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobs', 'query');
    },
    getJobsPlanner(variables?: GetJobsPlannerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobsPlannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobsPlannerQuery>(GetJobsPlannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobsPlanner', 'query');
    },
    getMachines(variables?: GetMachinesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMachinesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMachinesQuery>(GetMachinesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMachines', 'query');
    },
    getPartnerData(variables?: GetPartnerDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPartnerDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerDataQuery>(GetPartnerDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartnerData', 'query');
    },
    getPermissionSettings(variables?: GetPermissionSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPermissionSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPermissionSettingsQuery>(GetPermissionSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPermissionSettings', 'query');
    },
    getPlannerCachePrefill(variables?: GetPlannerCachePrefillQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPlannerCachePrefillQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlannerCachePrefillQuery>(GetPlannerCachePrefillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlannerCachePrefill', 'query');
    },
    getPublicFeatureFlags(variables?: GetPublicFeatureFlagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPublicFeatureFlagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublicFeatureFlagsQuery>(GetPublicFeatureFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPublicFeatureFlags', 'query');
    },
    getRequestableParts(variables?: GetRequestablePartsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRequestablePartsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRequestablePartsQuery>(GetRequestablePartsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRequestableParts', 'query');
    },
    getPreOrderedParts(variables: GetPreOrderedPartsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPreOrderedPartsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPreOrderedPartsQuery>(GetPreOrderedPartsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPreOrderedParts', 'query');
    },
    getStockEnquiry(variables?: GetStockEnquiryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStockEnquiryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStockEnquiryQuery>(GetStockEnquiryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStockEnquiry', 'query');
    },
    getStockList(variables?: GetStockListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStockListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStockListQuery>(GetStockListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStockList', 'query');
    },
    getSuggestedParts(variables?: GetSuggestedPartsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSuggestedPartsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSuggestedPartsQuery>(GetSuggestedPartsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSuggestedParts', 'query');
    },
    getTechnicians(variables?: GetTechniciansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTechniciansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTechniciansQuery>(GetTechniciansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTechnicians', 'query');
    },
    getUserEndpoints(variables: GetUserEndpointsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserEndpointsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserEndpointsQuery>(GetUserEndpointsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserEndpoints', 'query');
    },
    getUserSettings(variables?: GetUserSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserSettingsQuery>(GetUserSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserSettings', 'query');
    },
    getWorkNotes(variables: GetWorkNotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetWorkNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWorkNotesQuery>(GetWorkNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWorkNotes', 'query');
    },
    refreshJob(variables: RefreshJobQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshJobQuery>(RefreshJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshJob', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;